import { sendEventToDataLayer } from './gtm';
import { trackMixPanelEvent } from './mixpanel';

function trackEvent(eventName, data) {
    if (process.env.REACT_APP_MIXPANEL_ACTIVE.toLowerCase() === 'true') {
        trackMixPanelEvent(eventName, data || {});
    }
    if (process.env.REACT_APP_GTM_TRACKING_ACTIVE.toLowerCase() === 'true') {
        sendEventToDataLayer(eventName, data || {});
    }
}

export { trackEvent };